import template from './modal.html';
import './modal.scss';
/**
 * @ngdoc component
 * @name modal
 * @description
 * The modal component of the app.
 *
 * @memberof common
 */
export default {
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String} title      The modal title placeholder.
   * @property {String} body       The modal body text.
   * @property {Array} buttons     The modal buttons.
   * @property {Function} onClose  The callback when the close icon is clicked.
   */
  bindings: {
    title: '@',
    body: '@',
    buttons: '<',
    onClose: '&',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/common/components/modal/modal.component.js